/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from 'react'
import { ContentSection, Modal, TitleSection, ModalTitle, Row, Color, Chip } from "trux"
import { convertInningTitles } from "../../util/helpers";

export const SelectInningDialog = ({modalOpen, setSelectInningModalOpen, allInnings, selectedInning, setSelectedInning, parent}) => {

	const onSelectInning = (selectedInning) => {
		setSelectedInning(selectedInning)
		setSelectInningModalOpen(false)
	}

	return (
		<Modal
			trkContext={`Select Inning Dialog`}
			className="select-inning-dialog"
			open={modalOpen}
			onShadeClick={() => setSelectInningModalOpen(false)}
			parent={parent}
		>
			<TitleSection onCloseClick={() => setSelectInningModalOpen(false)}>
				<ModalTitle content="Filter innings"/>
			</TitleSection>
			<ContentSection>
				<Row justifyContent="center" spacingBottom="4">
					<Chip
						key={'all-innings'}
						content={`All innings`}
						background={selectedInning === "all-innings" ? Color.Black : Color.Grey4}
						color={selectedInning === "all-innings" ? Color.White2 : Color.Black}
						fat
						marginRight="1"
						marginTop="1"
						marginBottom="1"
						trkAction={`Selected All Innings`}
						onClick={() => onSelectInning('all-innings')}
					/>
					{
						allInnings.map(inning => {
							return (
								<Chip
									key={inning}
									content={convertInningTitles(inning)}
									background={inning === selectedInning ? 'black-color' : 'grey4-color'}
									color={inning === selectedInning ? 'white2-color' : 'black-color'}
									marginRight="1"
									marginTop="1"
									marginBottom="1"
									fat
									trkAction={`Selected Inning ${inning}`}
									onClick={() => onSelectInning(inning)}
								/>
							)
						})
					}
				</Row>
			</ContentSection>
		</Modal>
	)
}